export const replaceDynamicValues = (str, keyValuePairs) => {
  let newString = str
  for (const [key, value] of Object.entries(keyValuePairs)) {
    if (value)
      newString = newString.replace(`{{${key}}}`, value)
  }
  return newString
}
